import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import ResultsImage from "./resultsimage"

const ImageGroup = styled(Flex)`
  height: 100%;
  justify-content: space-around;
`

const ImageWrapper = styled(Box)``

const ResultImageGroup = ({ before, after, imageDirection, badgePosition }) => (
  <ImageGroup className={`results-imagegroup`}>
    <ImageWrapper>
      <ResultsImage
        badgePosition={badgePosition}
        imageDirection={imageDirection}
        image={before.image}
        label={before.label}
        alt={before.alt}
        role="presentation"
      />
    </ImageWrapper>
    <ImageWrapper>
      <ResultsImage
        badgePosition={badgePosition}
        imageDirection={imageDirection}
        image={after.image}
        label={after.label}
        alt={after.alt}
        role="presentation"
      />
    </ImageWrapper>
  </ImageGroup>
)

export default ResultImageGroup
